<div class="form-row">
  <div style="width: 150px">
    <label
      id="labelContaExtrato"
      class="font-menu-titulo label-titulo"
      for="inputContaExtrato"
      >{{ labelDadosBancarios }}</label
    >
    <app-drop-down
      id="dropdownContasCliente"
      class="dados_internos label-operacoes"
      [selecionaItem]="selecaoAgenciaConta"
      [listItem]="contas"
      [dropDownConfig]="dropDownContaConfig"
      (valorSelecionado)="recebeValorSelecionado($event)"
    >
    </app-drop-down>
    <label
      id="labelMensagemErroContas"
      class="mensagem-erro-contas"
      *ngIf="mensagemValidacaoContas !== null"
      >{{ mensagemValidacaoContas }}</label
    >
  </div>
  <div
    class="col-md-auto loading-controle"
    [ngClass]="
      exibirCarregamentoContas === true
        ? 'loading-visivel'
        : 'loading-invisivel'
    "
  >
    <img
      id="loadingImgSelecaoConta"
      src="./assets/img/spinner-125.svg"
      style="height: 25px; width: 20px"
    />
  </div>
</div>
